export const HOME_PATH = 'home'
export const LOGIN_PATH = 'login'
export const LOGOUT_PATH = 'logout'
export const ACCESS_TOKEN_KEY = 'samtycke-at'